const sortByProperty = <T>(items: T[], prop: keyof T): T[] => {
  return [...items].sort((a, b) => {
    if (a[prop] < b[prop]) {
      return -1
    }
    if (a[prop] > b[prop]) {
      return 1
    }
    return 0
  })
}

export { sortByProperty }



// WEBPACK FOOTER //
// ./src/utils/array-helper.ts